export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10195.6a52c046.jpg";